import {  
  loadEnumGroupDataInProgress,
  loadEnumGroupDataSuccess,
  loadEnumGroupDataFailure,
  enumGroupOperationCompleted,
  loadEnumGroupSingleData,
} from "../state/enumsgroup/actions";
import swal from 'sweetalert';
import configData from "../config.json";
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert, fileSchemaSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
const serverBasePath=configData.SERVER_API_URL;


export const loadEnumsGroupList = (page=0,pageSize=10) => async (dispatch) => {
  
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadEnumGroupDataInProgress());
    const response = await fetch(serverBasePath+"/enumsgroup/getEnumsGroupList?page="+page+"&pageSize="+pageSize,
    {
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadEnumGroupDataSuccess(result));
  } catch (e) {
    dispatch(loadEnumGroupDataFailure());
    errorSweetAlert(e); 
  }
};

export const addNewEnumsGroupFile = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadEnumGroupDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/enumsgroup/addNewEnumsGroupFile", 
      {
        method: "POST",  
        headers: {
          Authorization: 'Bearer ' + token,       
          'type': 'formData',
        },
        body:data
      });
      dispatch(enumGroupOperationCompleted());
      const result = await response.json();
      if(response.status === 500 && result?.errors){
          fileSchemaSweetAlert(result);
          return;
      }
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      //dispatch(closeUnitsAndEnumsDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadEnumsGroupList(''));
        }
      });
  } catch (e) {
      dispatch(loadEnumGroupDataFailure());
      errorSweetAlert(e);
  }
};


export const deleteEmumsGroup = (id) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadEnumGroupDataInProgress());
          const response = await fetch(serverBasePath+"/enumsgroup/delete/"+id,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(enumGroupOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadEnumsGroupList(''));
              }
          });
      } catch (e) {   
          dispatch(loadEnumGroupDataFailure());
          errorSweetAlert(e); 
      }
  };
};


export const setLatestEmumsGroup = (rowId) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken(); 
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadEnumGroupDataInProgress());
          const response = await fetch(serverBasePath+"/enumsgroup/"+rowId+"/setlatest",
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(enumGroupOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadEnumsGroupList(''));
              }
          });
      } catch (e) {   
          console.log(e)
          dispatch(loadEnumGroupDataFailure());
          errorSweetAlert(e); 
      }
  };
};



export const loadEnumGroupEditData = (rowId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken(); 
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadEnumGroupDataInProgress());
        const response = await fetch(serverBasePath+"/enumsgroup/getEnumGroupContent/"+rowId,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(enumGroupOperationCompleted()); 
        const data = await response.json();
        if(response.status !== 200){
            swal({
              title: 'Oops!',
              text: "There is some error while fetching the data. Please try again.",
              icon: "error",
              dangerMode: true,
          });
            return;
        }
        dispatch(loadEnumGroupSingleData(data));   
    } catch (e) {
        dispatch(loadEnumGroupDataFailure());   
        errorSweetAlert(e);
    }
};



export const downloadEnumGroupFile = (rowId,fileName) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken(); 
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadEnumGroupDataInProgress());
            const response = await fetch(serverBasePath+"/enumsgroup/"+rowId+"/download",
            {
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(enumGroupOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`${fileName}.json`); 
            document.body.appendChild(link);
            link.click();
            dispatch(enumGroupOperationCompleted()); 
        } catch (e) {   
            dispatch(loadEnumGroupDataFailure());
            errorSweetAlert(e);  
        }
    };
};